'use strict'

var scoped = /^:scope/

var nonBubbling = {
  blur: true,
  focus: true,
  scroll: true,
  submit: true,
  mouseenter: true,
  mouseleave: true
}

function nextTick(func) {
  Promise.resolve().then(func)
}

var scopeSupport = null;

function testScopeSupport(){
  var elem = document.createElement('div');
  var div = document.createElement('div');
  div.appendChild(document.createElement('div'));
  elem.appendChild(div);
  
  try {
    elem.querySelectorAll(':scope>div')
    scopeSupport = true;
  } catch (e) {
    scopeSupport = false;
  }
}


function id() {
  return 'x'+(((1+Math.random())*0x10000)|0).toString(16).substring(1)+
  (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
}

function scopeShim(node, selector){
  if(scopeSupport === null)
    testScopeSupport();

  if(!scopeSupport){
    if(node.hasAttribute('id')){
      var uid = node.getAttribute('id');
    }else{
      var uid = id();
      while ( document.getElementById(uid) )
        uid = id()
      node.setAttribute('id', uid);
    }
    selector = '#' + uid + selector.substring(6);
  }
  return selector;
}

export function index(node) {
  var i = 0
  node = node.previousElementSibling
  while (node) {
    ++i
    node = node.previousElementSibling
  }
  return i
}

export function width(node) {
  return parseInt(window.getComputedStyle(node, null).getPropertyValue('width'))
}

export function query(node, selector) {
  if (typeof selector === 'undefined') {
    selector = node
    node = document
  }
  if(scopeSupport !== true && scoped.test(selector)){
    selector = scopeShim(node, selector);
  }
  return node.querySelector(selector)
}

export function queryAll(node, selector) {
  if (typeof selector === 'undefined') {
    selector = node
    node = document
  }
  if(scopeSupport !== true && scoped.test(selector)){
    selector = scopeShim(node, selector);
  }
  return node.querySelectorAll(selector)
}

export function newNode(html) {
  var template = document.createElement('template')
  template.innerHTML = html
  return template.content.firstChild
}

export function replace(oldNode, newNode) {
  if (typeof newNode === 'string') {
    newNode = newNode(newNode)
  }
  oldNode.parentNode.insertBefore(newNode, oldNode)
  oldNode.parentNode.removeChild(oldNode)
}

export function ready(func, complete) {
  var state = document.readyState
  if ((state == 'interactive' && !complete) || state == 'complete') {
    nextTick(func)
    return
  }
  if (complete) {
    document.addEventListener('load', func)
  } else {
    document.addEventListener('DOMContentLoaded', func)
  }
}

export function on(node, type, selector, func) {
  var handler, capture = false
  
  if ( !(node instanceof Element) && !(node instanceof Document)) {
    func = selector
    selector = type
    type = node
    node = document
  }
  
  if (typeof func === 'undefined') {
    func = selector
    selector = false
  }
  
  if ( !selector) {
    handler = func
  } else if (scoped.test(selector)) {
    handler = function (event) {
      var nodes, i, c
      //nodes = node.querySelectorAll(selector)
      nodes = queryAll(node, selector)
      for (i = 0, c = nodes.length; i < c; ++i) {
        if (nodes[i] === event.target) {
          return func.call(event.target, event)
        }
      }
    }
  } else {
    handler = function (event) {
      var target = event.target
      while (target && target.matches) {
        if (target.matches(selector)) {
          return func.call(target, event)
        }
        if (target != this) {
          target = target.parentElement
        }
      }
    }
  }
  if (selector && nonBubbling.hasOwnProperty(type)) {
    capture = true
  }
  node.addEventListener(type, handler, capture)
  return function() {
    node.removeEventListener(type, handler, capture)
  }
}